import { httpRequest } from "@services/http"

export class CommandDeleteLaunchNetworkPolicy {
  async run(launchId: number, network: string): Promise<void> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/launches/${launchId}/policies/budget/`
    await httpRequest(url, { method: "DELETE", body: { network } })
  }
}
